module.exports = __webpack_public_path__ + "img/北京办公室3.6ee10a31.jpg";